module.exports = __webpack_public_path__ + "media/images/favicon-c6c5f3743ce191f6f77900c91229b95f.png";